import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Experience from "./pages/Experience";
import Teaching from "./pages/Teaching";
import HomePage from "./pages/HomePage";
import Talks from "./pages/Talks";
import Softwares from "./pages/Softwares";

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/experience" element={<Experience />} />
      <Route path="/teaching" element={<Teaching />} />
      <Route path="/talks" element={<Talks />} />
      <Route path="/softwares" element={<Softwares />} />

    </Routes>
  );
}

export default App;
